import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import { Card, Grid } from "@mui/material";
import axios from "axios";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

const formatEmployeeType = (value = "") =>
  String(value || "")
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export default class Employees extends Component {
  state = {
    employees: [],
    message: "",
    notification: false,
    noticolor: "success",
    pagination: {
      page: 1,
      totalPages: 1,
      totalDocs: 0,
    },
    per_page: 20,
    page_no: 1,
    redirect: false,
  };

  componentDidMount() {
    this.getAllEmployees(this.state.page_no, this.state.per_page);
  }

  getAllEmployees = (page, limit) => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    axios
      .get(`${Constants.getUrls.getAllEmployees}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            employees: resp.data.data.docs || [],
            pagination: resp.data.data,
            page_no: resp.data.data.page,
          });
        }
      })
      .catch((err) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: err?.response?.data?.message || "Failed to fetch employees.",
        });
      });
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllEmployees(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllEmployees(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this employee?")) {
      return;
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    axios
      .post(Constants.deleteUrls.deleteEmployee, { id })
      .then((resp) => {
        this.setState({
          notification: true,
          noticolor: "success",
          message: resp.data.message,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
          this.getAllEmployees(this.state.page_no, this.state.per_page);
        }, 2000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: err?.response?.data?.message || "Failed to delete employee.",
        });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/signin" replace={true} />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Employee List
              </MDTypography>
            </MDBox>
            <Grid item sm={4} px={2} align="right">
              <Link to="/addEmployee">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>
            <MDBox>
              <DataTable
                table={{
                  columns: [
                    { Header: "serial", accessor: "serial", width: "6%" },
                    { Header: "name", accessor: "name" },
                    { Header: "employee id", accessor: "employee_id" },
                    { Header: "mobile", accessor: "mobile" },
                    { Header: "email", accessor: "email" },
                    { Header: "role", accessor: "employee_type" },
                    { Header: "status", accessor: "status" },
                    { Header: "salary", accessor: "salary" },
                    { Header: "created by", accessor: "admin" },
                    { Header: "action", accessor: "action" },
                  ],
                  rows: this.state.employees.map((item, index) => ({
                    serial:
                      (Number(this.state.page_no || 1) - 1) * Number(this.state.per_page || 20) +
                      index +
                      1,
                    name: item.name || "-",
                    employee_id: item.employee_id || "-",
                    mobile: item.mobile || "-",
                    email: item.email || "-",
                    employee_type: formatEmployeeType(item.employee_type) || "-",
                    status: item.status || "-",
                    salary:
                      item.salary !== undefined && item.salary !== null && item.salary !== ""
                        ? item.salary
                        : "-",
                    admin: item?.admin?.name || "-",
                    action: (
                      <>
                        <div>
                          <Link to={`/updateEmployee/${item._id}`}>
                            <MDButton variant="outlined" size="small" color="success">
                              Update
                            </MDButton>
                          </Link>
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => this.handleDelete(item._id)}
                          >
                            Delete
                          </MDButton>
                        </div>
                      </>
                    ),
                  })),
                }}
                entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                page_no={this.state.pagination?.page}
                totalPages={this.state.pagination?.totalPages}
                totalDocs={this.state.pagination?.totalDocs}
                onPageChange={this.handlePageChange}
                onEntriesPerPageChange={this.handleEntriesPerPageChange}
              />
            </MDBox>
            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
